import { render, staticRenderFns } from "./TrasferisciCertificato.vue?vue&type=template&id=22207116"
import script from "./TrasferisciCertificato.vue?vue&type=script&lang=js"
export * from "./TrasferisciCertificato.vue?vue&type=script&lang=js"
import style0 from "./TrasferisciCertificato.vue?vue&type=style&index=0&id=22207116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports